import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, map } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { environment } from 'src/environments/environment'
import { getFilterParams } from '../../helpers/get-filters'
import { WolseleyPrice } from 'src/app/shared/interfaces/wolseley/wolseley-price.interface'
import { RequestStock } from 'src/app/shared/interfaces/wolseley/request-stock.interface'
import { WolseleyStock2 } from 'src/app/shared/interfaces/wolseley/wolseley-stock2.interface'
import { WolseleyOrder } from 'src/app/shared/interfaces/wolseley/wolseley-order.interface'
import { WolseleyOrderResponse } from 'src/app/shared/interfaces/smartquote/wolseley-order-response.interface'

@Injectable({
    providedIn: 'root',
})
export class WolseleyService {
    private httpClient = inject(HttpClient)

    getWolseleyStock2(request: RequestStock): Observable<WolseleyStock2> {
        return this.httpClient
            .post<ApiResponse<WolseleyStock2>>(`${environment.baseUrl}wolseley/stockv2`, request)
            .pipe(map((x) => x.result))
    }

    getWolseleyPrices(productCodes: string[]): Observable<WolseleyPrice> {
        const params = getFilterParams({ productCodes })
        return this.httpClient
            .get<ApiResponse<WolseleyPrice>>(`${environment.baseUrl}wolseley/prices`, { params })
            .pipe(map((x) => x.result))
    }

    placeWolseleyOrder(request: WolseleyOrder) {
        return this.httpClient
            .post<ApiResponse<WolseleyOrderResponse>>(`${environment.baseUrl}wolseley/order`, request)
            .pipe(map((x) => x.result))
    }
}
